// import React, { useEffect, useState } from 'react'
// import ListinngCard from '../layouts/ListingCard'
// import EcomDashboardHeaderNew from './Ecom Orders/EcomDashboardHeaderNew'
// import SummaryHeader from './SummaryHeader'
// import moment from 'moment'
// import LoaderImage from './LoaderImage'
// import { DatePicker, message } from 'antd';
// import CalenderImg from '../assets/images/calender.png';
// import { SearchBar } from '../layouts/SearchBar'

// const ResultSummary = () => {
//     const [renderList, setrenderList] = useState([])
//       const [searchShow, setSearchShow] = useState({});
    
//     const tableHeaders = [
//         "Products","Total Activated","Shipped to Lab","Received at Lab","Waiting for Result","Completed"
//     ]
//       const { RangePicker } = DatePicker;
//     const [loading, setLoading] = useState(false);
//      useEffect(() => {
//         let formData = {
//           limit: 10,
//           offset: 0,
//           orderDateFrom: '', //2023-03-03  only give date without time
//           orderDateTo: '',
//           filterBy: '',
//           filterParam: '',
//         };
//         dashboardListingApi(formData);
//         // setTableHeaders(headersMap.get(activeIndex));
//         // return () => {};
//       }, []);
//   const dashboardListingApi = async (formData) => {
//     console.log(formData);
//     console.log('searchshow', searchShow);

//     console.log(formData);
//     // console.log('isSearch,isSearch', isSearch);

//     // if (isSearch) {
//     //   formData.searchBy = pagin.searchBy;
//     //   formData.searchTxt = pagin.searchTxt;
//     // setCurrentPage(1);
//     // }
//     // console.log("data here is : ",formData);

//     setLoading(true);
//     const resp = await axios.post(`${app.URL}/api/v1/admin/dashboard/listing`, formData, { headers: getHeaders() });
//     // const resp = await axios.post(`http://localhost:3200/api/v1/admin/dashboard/listing`, formData, { headers: getHeaders() });

//     // console.log(resp);
//     // roleResp.data ? setFetchedRoles(roleResp.data.result.data) : ' ';
//     resp.data ? setCount(resp.data.result.data.count) : ' ';
//     // resp.data ? setCurrentPage(1) : ' ';
//     resp.data ? setRender(resp.data.result.data.data) : ' ';

//     // new additions
//     resp.data ? setActivatedCount(resp.data.result.data.status[0].count) : ' ';
//     resp.data ? setawatingCount(resp.data.result.data.status[1].count) : ' ';
//     resp.data ? setCompletedCount(resp.data.result.data.status[2].count) : ' ';
//     resp.data ? setCurrentPage(1) : ' ';
//   };
//       const durationSelect = async (value) => {
//         console.log('value ', value);
//         let formData = {
//           limit: 10,
//           offset: 0,
//           filter:value??0
         
//         };
//         dashboardListingApi(formData);
//         // setorderDateFrom('')
//         // setorderDateTo('')
//         //  return
//         //  durationSelection(getInProgressData, value, setorderDateFrom, setorderDateTo, activeIndex, searchShow, 10, 0, 'productName');
//         // durationSelection(dashboardListingApi, value, setorderDateFrom, setorderDateTo, activeIndex, searchShow, 10, 0, 'productName', setdateSelector, true, dateSelector, true, setCurrentPage);
//       };
    
//     const onSearchFinishFailed = (values) => {
//       console.log('Failed:', values);
//     };
    
//        const onSearchFinish = async (values) => {
//           console.log('onSearchFinish');
         
//           console.log('Success:', values ,searchShow);
//           let formData = {
//             limit: 10,
//             offset: 0,
//             // searchBy: values.searchBy, //partnerName, serialNo, orderNo
//             // searchTxt: values.searchTxt,
//             // status: activeIndex, //1 = In-Transit (Inprogress), 2 = Sent to Lab, 3 = Completed
//             orderDateFrom: searchShow.dateFrom ? searchShow?.dateFrom : '', //2023-03-03  only give date without time
//             orderDateTo: searchShow.dateTo ? searchShow?.dateTo : '',
//             // filterBy: values?.filterBy ? values.filterBy : '',
//             // filterParam: values?.filterParam ? values.filterParam : '',
//           };
//           if (formData.searchTxt) {
//             console.log('formData.searchTxt', formData.searchTxt);
      
//             // setisSearch(true)
//             // setSearchShow({ searchFor: formData.searchBy, searchItem: formData.searchTxt });
//           }
//           // setSearchShow({ searchBy: values.searchBy, searchTxt: values.searchTxt });
//           if (!searchShow?.dateFrom) message.error('Please enter search text');
//           // console.log(formData)
//           else {
//             await dashboardListingApi(formData);
//             // setCurrentPage(1)
//           }
//         };
//     const resultSummaryListing = (tableValues) => {
//       return (
//         <>
//           {/* <td>{tableValues.anuraParamId}</td> */}
//           <td>{tableValues?.productName}</td>
//           <td>{tableValues?.totalActivated}</td>
//           <td>{tableValues?.Shipped}</td>
//           <td>{tableValues?.received}</td>
//           <td>{tableValues?.waiting}</td>

//           <td>{tableValues?.completed}</td>

//           {/* <td>{tableValues.isActive ? 'Active' : 'Inactive'}</td> */}
//         </>
//       );
//     };
//      const onChange = async (date, dateString) => {
//        console.log('onChangeonChange', date, dateString);
//        setSearchShow({ dateFrom: dateString[0], dateTo: dateString[1]});
//         // onChangeMethod(dashboardListingApi, dateString, setorderDateFrom, setorderDateTo, activeIndex, searchShow, pageSize, pageSize * (currentPage - 1), 'productName');
//       };
//     return (
//       <>
//         <div className='dashboard-card container-fluid'>
//           <div className='row p-0 '>
//             <div className='for-before col-12 col-lg-6 col-md-8 head fs-3 fw-bold' style={{ backgroundColor: '#a7c1d9', borderBottomRightRadius: '10px', color: '#FFFFFF' }}>
//               Result Summary Dasbord
//             </div>

//             {/* <TestOrderDetailModal isVisible={isVisible} setIsVisible={setIsVisible} testOrderDetails={testOrderDetails} displayPSTDate={displayPSTDate} dateTimeFormatWithTimeZone={dateTimeFormatWithTimeZone} isTestOrder={true} /> */}
//             <div className='col-12 mt-2 col-lg-4 col-md-3' style={{ position: 'relative' }}>
//               <img className='calender-img' src={CalenderImg} />
//               <select className='form-control drop-down-select' name='dates' id='date' onChange={(e) => durationSelect(e.target.value)}>
//                 <option value="7Days">last 7 Days</option>
//                 <option value="15Days">last 15 Days</option>
//                 <option value="30Days">last 30 Days</option>
//                 {/* <option value={moment().subtract(1, 'year').format('YYYY-MM-DD')}>last year</option> */}
//               </select>
//             </div>
//           </div>

//           {/* <RadarChart reportData={reportData} /> */}
//           {/* { activeIndex === 4 ? <di>No filters available for the selected section.</di> : <SearchBar onFinish={onSearchFinish} onFinishFailed={onSearchFinishFailed} searchItems={activeIndex === 1 ? ActivatedItem :  AwaitingItem } onChange={handleOnChange} />} */}
//           <SearchBar onFinish={onSearchFinish} onFinishFailed={onSearchFinishFailed} searchItems={{}} onChange={onChange} isSummary={true} />
//           {loading && <LoaderImage />}

//           <div className='table-scrollbar '>
//             {tableHeaders.length > 0 && !loading ? (
//               <table id='customers' className='w-100'>
//                 <thead className='w-100'>
//                   <tr>
//                     {tableHeaders.map((header) => (
//                       <th key={header}>{header}</th>
//                     ))}
//                   </tr>
//                 </thead>
//                 <tbody>
//                   {renderList.length > 0 ? (
//                     renderList.map((output, index) => <tr key={index}>{resultSummaryListing(output)}</tr>)
//                   ) : (
//                     <tr>
//                       <td colSpan={tableHeaders.length} className='text-center'>
//                         No data available
//                       </td>
//                     </tr>
//                   )}
//                 </tbody>
//               </table>
//             ) : (
//               <>{!loading && <NoDataFound />}</>
//             )}
//           </div>
//           {renderList.length > 0 && (
//             <div className='row'>
//               <Pagination style={{ marginBottom: '20px' }} onChange={onPageChange} defaultCurrent='1' current={currentPage} total={count} showTotal={(total) => `Total ${total} items`} showSizeChanger />

//               {/* <Pagination style={{ marginBottom: '20px' }} onChange={onPageChange} defaultCurrent={currentPage} total={count} showTotal={(total) => `Total ${total} items`} showSizeChanger /> */}
//             </div>
//           )}
//         </div>

//         {/* <SummaryHeader onChange={onChange} durationSelect={durationSelect} />

//         <ListinngCard
//           heading='Result Summary Dasboard'
//           // buttonName='Add Vital Package'
//           // addButton={addFacialPackage}
//           // onSearch={onFinish}
//           // onSearchFailed={onFinishFailed}
//           // searchItems={searchItems}

//           tableHeaders={tableHeaders}
//           tableRows={renderList}
//           // editButton={editFacialPackage}
//           // editButton={editProduct}   --------    conditional rendering ask?

//           // will use

//           // onPageChange={onPageChange}
//           // currentPage={currentPage}
//           // pagesCount={pagesCount}
//           anuraListing={false}
//           inventoryBatchListing={false}
//           patientsListing={false}
//           inventoryListing={false}
//           userListings={false}
//           storeListing={false}
//           resultSummaryListing={true}
//           testResultListing={false}
//           stockBalanceListing={false}
//           productListing={false}
//           BlogsListing={false}
//           facialPackageListing={true}
//           notShowSearch={true}

//           // searchValue={searchData}

//           // onChange={handleOnChange}
//           // loader={loader}
//         /> */}
//       </>
//     );
// }

// export default ResultSummary

import React, { useEffect, useState } from 'react';
import moment from 'moment';
import axios from 'axios';
import { DatePicker, message, Pagination } from 'antd';

import ListinngCard from '../layouts/ListingCard';
// import SummaryHeader from './SummaryHeader';
import LoaderImage from './LoaderImage';
import CalenderImg from '../assets/images/calender.png';
import { SearchBar } from '../layouts/SearchBar';
import NoDataFound from '../layouts/NoDataFound';
import { app } from '../config';
import getHeaders from '../utils/authHeaders';
// import app from '../config'; // Your base URL or app config

const { RangePicker } = DatePicker;

const ResultSummary = () => {
  const [renderList, setRender] = useState([]);
  const [searchShow, setSearchShow] = useState({});
  const [loading, setLoading] = useState(false);
  const [count, setCount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRange, setSelectedRange] = useState(null); 
  //  const []
  const tableHeaders = ['Products', 'Total Activated', 'Shipped to Lab', 'Received at Lab', 'Waiting for Result', 'Completed'];

  const getDefaultFormData = () => ({
    limit: 10,
    offset: 0,
    filter: 'last7Days',
  });

  useEffect(() => {
    fetchDashboardData(getDefaultFormData());
  }, []);

  const fetchDashboardData = async (formData) => {
    try {
      setLoading(true);
      let queryParams = '';

      if (formData.filter) {
        queryParams = `searchType=${formData.filter}`;
      } else if (formData.orderDateFrom && formData.orderDateTo) {
        queryParams = `startDate=${formData.orderDateFrom}&endDate=${formData.orderDateTo}`;
      }

      const url = `${app.URL}/api/v1/admin/dashboard/view${queryParams ? `?${queryParams}` : ''}`;

      const resp = await axios.get(url, {
        headers: getHeaders(),
      });

      const data = resp.data?.result?.data;
      if (data) {
        setRender(data);
        setCount(data.count);
        setCurrentPage(1);
      }
    } catch (err) {
      console.error('Error fetching data', err);
    } finally {
      setLoading(false);
    }
  };

  const durationSelect = (value) => {
    const formData = getDefaultFormData();
    formData.filter = value;
    fetchDashboardData(formData);
  };

  const onChangeDateRange = (dates, dateStrings) => {
    setSelectedRange(dates); 
    if (dateStrings[0] && dateStrings[1]) {
      setSearchShow({ dateFrom: dateStrings[0], dateTo: dateStrings[1] });
    }
  };

  
  const onSearchFinish = async () => {
    if (!searchShow?.dateFrom || !searchShow?.dateTo) {
      message.error('Please select a date range');
      return;
    }

    const formData = {
      limit: 10,
      offset: 0,
      orderDateFrom: searchShow.dateFrom,
      orderDateTo: searchShow.dateTo,
    };
    await fetchDashboardData(formData);
    setSearchShow({});
    setSelectedRange(null); 
  };

  const onPageChange = (page) => {
    setCurrentPage(page);
    const formData = getDefaultFormData();
    formData.offset = (page - 1) * 10;
    fetchDashboardData(formData);
  };

  const renderRow = (item) => (
    <>
      <td>{item?.productName}</td>
      <td>{item?.totalActivated ?? 0}</td>
      <td>{item?.Shipped ?? 0}</td>
      <td>{item?.received ?? 0}</td>
      <td>{item?.waiting ?? 0}</td>
      <td>{item?.completed ?? 0}</td>
    </>
  );

  return (
    <div className='dashboard-card container-fluid'>
      <div className='row p-0'>
        <div
          className='for-before col-12 col-lg-6 col-md-8 head fs-3 fw-bold'
          style={{
            backgroundColor: '#a7c1d9',
            borderBottomRightRadius: '10px',
            color: '#FFFFFF',
          }}
        >
          Result Summary Dashboard
        </div>

        <div className='col-12 mt-2 col-lg-4 col-md-3 ' style={{ position: 'relative', margin: '0 auto' }}>
          <img className='calender-img' src={CalenderImg} alt='Calendar' />
          <select className='form-control drop-down-select' name='dates' id='date' defaultValue='last7Days' onChange={(e) => durationSelect(e.target.value)}>
            <option value='last7Days'>Last 7 Days</option>
            <option value='last15Days'>Last 15 Days</option>
            <option value='lastMonth'>Last 30 Days</option>
            <option value=''>All Records</option>
          </select>
        </div>
      </div>

      <SearchBar onFinish={onSearchFinish} searchShow={searchShow} onFinishFailed={() => message.error('Search Failed')} searchItems={{}} onChange={onChangeDateRange} isSummary={true} selectedRange={selectedRange} setSelectedRange={setSelectedRange} />

      {loading && <LoaderImage />}

      <div className='table-scrollbar'>
        {tableHeaders.length > 0 && !loading ? (
          <table id='customers' className='w-100'>
            <thead>
              <tr>
                {tableHeaders.map((header) => (
                  <th key={header}>{header}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {renderList.length > 0 ? (
                renderList.map((item, index) => <tr key={index}>{renderRow(item)}</tr>)
              ) : (
                <tr>
                  <td colSpan={tableHeaders.length} className='text-center'>
                    No data available
                  </td>
                </tr>
              )}
            </tbody>
          </table>
        ) : (
          !loading && <NoDataFound />
        )}
      </div>

      {/* {renderList.length > 0 && (
        <div className='row'>
          <Pagination style={{ marginBottom: '20px' }} current={currentPage} defaultCurrent={1} total={count} onChange={onPageChange} showTotal={(total) => `Total ${total} items`} showSizeChanger={false} />
        </div>
      )} */}
    </div>
  );
};;

export default ResultSummary;
